<div
  class="tipo-de-obra-content titles"
  appDropdownToggle
  #dropdown="dropdownToggle"
  (click)="dropdown.toggle()"
  tabindex="0"
>
  <div class="icon-text">
    <span class="icon-circle">
      <img
        class="img-icon"
        src="{{
          BASE_IMG_URL
        }}assets/filtro-lateral-busca/search_check.svg"
        alt=""
        width="22"
        height="22"
      />
    </span>
    <h2>Buscas Salvas</h2>
  </div>
  <a
    class="btn tipo-de-obra-link"
    data-bs-toggle="collapse"
    role="button"
    aria-expanded="true"
    href="#btn-buscas"
    (click)="$event.stopPropagation(); dropdown.toggle()"
    (keydown.enter)="dropdown.toggle()"
    (keydown.space)="dropdown.toggle()"
  >
    <img
      class="img-icon"
      [ngClass]="{ 'girar-icon': dropdown.isOpen }"
      src="{{
        BASE_IMG_URL
      }}assets/filtro-lateral-busca/icone-seta-fechar.svg"
      alt=""
      width="18"
      height="18"
    />
  </a>
</div>

<div class="collapse show check-total" id="btn-buscas" *ngIf="dropdown.isOpen">
  @if (buscas.length > 0) {
  <div class="form-check busca-salva">
    <select
      [(ngModel)]="selectedBuscaId"
      (ngModelChange)="onBuscaSalvaChange($event, true)"
      [class.disabled]="disabled"
      [disabled]="disabled"
    >
      <option [value]="0" selected>Nenhuma busca selecionada</option>
      @for (busca of buscas; track $index) {
      <option [value]="busca.searchID">
        {{ busca.name }}
      </option>
      }
    </select>
  </div>
  } @else {
  <div class="busca-salva">
    <p>Nenhuma busca salva encontrada!</p>
  </div>

  }
</div>
